const Createlist = list => {
  const ArrayList = list.split("\n")
  return ArrayList
}

export default Createlist
